import {
	SearchShipmentsResult,
	ShipmentLog,
	type Id,
	type SearchShipmentsRequest,
	type ShipmentLogDocumentKey,
} from "@/models"
import { ApiService } from "@/services"
import type { PlainDate } from "@/temporal"

export interface CreateShipmentData {
	tfsId: Id
	shipmentNumber: number
	files: File[]
	recipients: string[]
}

export interface UploadShipmentFilesData {
	shipmentId: Id
	files: File[]
	type: ShipmentLogDocumentKey
	recipients: string[]
}

export class ShipmentsService extends ApiService {
	constructor() {
		super("/api/shipments")
	}

	async create(data: CreateShipmentData) {
		const formData = new FormData()
		formData.set("tfsId", String(data.tfsId))
		formData.set("shipmentNumber", String(data.shipmentNumber))

		for (const recipient of data.recipients) {
			formData.append("recipients", recipient)
		}
		for (const file of data.files) {
			formData.append("files", file)
		}

		return await this.returning(ShipmentLog).post("", formData)
	}

	async uploadDocuments(data: UploadShipmentFilesData) {
		const formData = new FormData()
		formData.set("shipmentId", String(data.shipmentId))

		for (const recipient of data.recipients) {
			formData.append("recipients", recipient)
		}
		for (const file of data.files) {
			formData.append("files", file)
		}

		return await this.returning(ShipmentLog).post(`upload/${data.type}`, formData)
	}

	async setShipmentDate(shipmentId: Id, date: PlainDate) {
		return await this.returningVoid().post(`${shipmentId}/shipment-date`, date)
	}

	async cancel(shipmentId: Id) {
		return await this.returningVoid().post(`${shipmentId}/cancel`, undefined)
	}

	async complete(shipmentId: Id) {
		return await this.returningVoid().post(`${shipmentId}/complete`, undefined)
	}

	async delete(shipmentId: Id) {
		return await this.returningVoid().delete(String(shipmentId))
	}

	async deleteDocument(key: ShipmentLogDocumentKey, documentId: string) {
		return await this.returningVoid().delete(`documents/${key}/${documentId}`)
	}

	async getNextNumber(tfsId: Id) {
		return await this.returning(Number).get(`next/${tfsId}`)
	}

	async search(request: SearchShipmentsRequest) {
		return await this.returning(SearchShipmentsResult).post("search", request)
	}
}
